export default __webpack_public_path__ + "static/buderus-3916e8d1b000f493536844e9c6aec02f.jpg";